import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

/**
 * The result of a save, shown beside the button that caused it: "Saved", the server's error, a
 * warning, or "Unsaved changes" while the form differs from what is saved.
 *
 * @param {{type: 'success'|'error'|'warning', message: string}|null} status
 */
export const SaveStatus = ({ status, dirty }) => {
  let className = 'save-status';
  let message = null;
  if (status) {
    message = status.message;
    if (status.type === 'success') className += ' is-success';
    else if (status.type === 'error') className += ' is-error';
    else className += ' text-warning';
  } else if (dirty) {
    message = 'Unsaved changes';
  }
  return (
    <span className={className} role="status" aria-live="polite">
      {message}
    </span>
  );
};

/**
 * A form's Save button with its result beside it. Save stays disabled until something changed;
 * pass dirty={null} when the form cannot tell, to leave it enabled. It is a submit button, so put
 * it inside the form (outside any disabled fieldset).
 */
const SaveBar = ({ dirty, saving, status, label = 'Save', disabled = false, sticky = false, className = '' }) => (
  <div className={`d-flex flex-wrap align-items-center gap-3 ${sticky ? 'form-sticky-actions' : 'mt-3'} ${className}`.trim()}>
    <Button type="submit" variant="primary" disabled={dirty === false || saving || disabled}>
      {saving && <Spinner as="span" animation="border" size="sm" aria-hidden="true" className="me-2" />}
      {saving ? 'Saving...' : label}
    </Button>
    <SaveStatus status={status} dirty={dirty === true} />
  </div>
);

export default SaveBar;
